import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "download",
  "use": "download-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"download\">\n<path d=\"M896 704v128h-768v-128h-128v256h1024v-256zM768 384h-192v-320h-128v320h-192l256 384z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol